import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';
import autoAdsManager from './utils/autoAdsManager';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    const pageTitle = document.title;
    const pageLocation = window.location.href;

    // Firebase Analytics
    if (analytics) {
      const ric = window.requestIdleCallback || ((fn) => setTimeout(fn, 1));
      ric(() => {
        try {
          logEvent(analytics, 'page_view', {
            page_path: pagePath,
            page_title: pageTitle,
            page_location: pageLocation,
          });
        } catch (_) {}
      });
    }

    // Google Analytics (Standard GA4)
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_location: pageLocation,
        page_path: pagePath,
        page_title: pageTitle,
        send_to: 'G-N6GJX3YQYT'
      });
    }

    // Request Auto Ads for new route (professional SPA behavior)
    autoAdsManager.requestAds(pagePath);
  }, [location, analytics]);
}